import Button from "@mui/material/Button"
import Slider from "@mui/material/Slider"

const DateFilterCom = ()=>{

    return(
        <div className='flex-column date-filter-cont ' >
            <div className="bar" />
            <p style={{textAlign:'center', marginBottom: 10}} >Filters are currently disabled. However, once we have enough users you can use all of them :)</p>
            
            <div style={{marginBottom: 10}} >
                <h4>Sex</h4>
                
            </div>
            <div className='flex-column' style={{marginBottom: 10}} >
                <h4>Age</h4>
                <Slider style={{color: 'purple'}} disabled={true} />
            </div>
            <div className='flex-column' >
                <h4>Distance</h4>
                <Slider style={{color: 'purple'}} disabled={true} />
            </div>
            <Button variant="contained">SAVE</Button>
        </div>
    )
}

export default DateFilterCom